import { Connection } from './classes'
import dispatch from './dispatch'

const api = new Connection({
  endpoint: 'https://spk-blog.prismic.io/api',
  queryPath: '/documents/search',
  dispatch
})

export { api as default }



// WEBPACK FOOTER //
// ./src/api/index.js